// src/UpdateQuantityModal.js

import React from 'react';

export function UpdateQuantityModal({ item, onUpdate, onClose }) {
    if (!item) return null;

    return (
        
        <div className="modal" onMouseDown={onClose}>
            <div className="modal-content" onMouseDown={e => e.stopPropagation()}>
                <h3>{item.name}</h3>
                <p>Quantità attuale: {item.quantity}</p>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', margin: '20px 0' }}>
                    <button onClick={() => onUpdate(item, 1)} style={{ padding: '15px 30px', fontSize: '1.5rem' }}>+ 1</button>
                    <button onClick={() => onUpdate(item, -1)} style={{ padding: '15px 30px', fontSize: '1.5rem' }}>- 1</button>
                </div>
                <button onClick={onClose} className="modal-button neutral-button">Chiudi</button>
            </div>
        </div>
    );
}